import React, { FC } from 'react';
import { Hyperlink } from '../../../../doctrine/components/Hyperlink';
import { MaterialIcon } from '../../../../doctrine/components/material-icon/MaterialIcon';
import { buildUrlWithParameters } from '../../../../doctrine/utils/url-utils/urlUtils';
import styles from './public_signup_banner.module.scss';

type Props = {
  button_text: string;
  subtitle: string;
  title: string;
  pageName: string;
};

export const PublicSignupBanner: FC<Props> = ({
  button_text,
  subtitle,
  title,
  pageName,
}) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <h2
        className={styles.title}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p className={styles.subTitle}>{subtitle}</p>
      <Hyperlink
        className={styles.link}
        href={buildUrlWithParameters('/inscription', {
          sourcePage: pageName,
        })}
      >
        <span className={styles.linkText}>{button_text}</span>
        <span className={styles.icon}>
          <MaterialIcon name="arrow_forward" />
        </span>
      </Hyperlink>
    </div>
  </div>
);
